export const actions = {
  initSocket: {
    request: payload => ({ payload, type: actions.initSocket.type }),
    type: 'initSocket',
  },
  subscribeTopic: {
    request: payload => ({ payload, type: actions.subscribeTopic.type }),
    type: 'subscribeTopic',
  },
  unsubscribeTopic: {
    request: (payload: { topics: string[] }) => ({ payload, type: actions.unsubscribeTopic.type }),
    type: 'unsubscribeTopic',
  },
  disconnect: {
    request: payload => ({ payload, type: actions.disconnect.type }),
    type: 'disconnect',
  },

  reconnectWithNewUri: {
    request: (payload: {
      uri: string;
      clientId?: string;
      username?: string;
      password?: string;
      subscribedTopics: string[];
    }) => ({
      payload,
      type: actions.reconnectWithNewUri.type,
    }),
    type: 'reconnectWithNewUri',
  },
};
